// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/list_medical_master.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MedicalMaster } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListMedicalMasterRequest
 */
export class ListMedicalMasterRequest extends Message<ListMedicalMasterRequest> {
  /**
   * Search term for filtering medical items
   *
   * @generated from field: string search = 1;
   */
  search = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of items per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListMedicalMasterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListMedicalMasterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMedicalMasterRequest {
    return new ListMedicalMasterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMedicalMasterRequest {
    return new ListMedicalMasterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMedicalMasterRequest {
    return new ListMedicalMasterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMedicalMasterRequest | PlainMessage<ListMedicalMasterRequest> | undefined, b: ListMedicalMasterRequest | PlainMessage<ListMedicalMasterRequest> | undefined): boolean {
    return proto3.util.equals(ListMedicalMasterRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListMedicalMasterResponse
 */
export class ListMedicalMasterResponse extends Message<ListMedicalMasterResponse> {
  /**
   * List of medical master records
   *
   * @generated from field: repeated com.neulink.pharmacy.MedicalMaster medical_masters = 1;
   */
  medicalMasters: MedicalMaster[] = [];

  /**
   * Total number of medical master records
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListMedicalMasterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListMedicalMasterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "medical_masters", kind: "message", T: MedicalMaster, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMedicalMasterResponse {
    return new ListMedicalMasterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMedicalMasterResponse {
    return new ListMedicalMasterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMedicalMasterResponse {
    return new ListMedicalMasterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMedicalMasterResponse | PlainMessage<ListMedicalMasterResponse> | undefined, b: ListMedicalMasterResponse | PlainMessage<ListMedicalMasterResponse> | undefined): boolean {
    return proto3.util.equals(ListMedicalMasterResponse, a, b);
  }
}

